import React, { forwardRef, useEffect, useContext, useState } from "react";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { AppStorage } from "../Utils/Context/AppContext";
import Request from "../Utils/Request/Request";
import { showToast } from "../Utils";
import moment from "moment";
import { getDocumentId } from "../Utils/documentNumber";

const InvoiceHtml = forwardRef(({ flag, sales }, ref) => {
  const { id } = useParams();
  const AppContext = useContext(AppStorage);
  const [invoiceData, setInvoiceData] = useState(null);
  const [userData, setUserData] = useState(null);
  console.log("ddd", flag, "ssss", sales);

  function getPrintInvoice() {
    Request.get(`/getPrintInvoice/${id}`)
      .then((result) => {
        setInvoiceData(result.data.invoice);
        setUserData(result.data.UserData);
      })
      .catch((err) => {
        console.log("Error: ", err);
        if (err.response.status === 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", "Something went wrong.");
        }
      });
  }

  useEffect(() => {
    if (
      (invoiceData?.companyName && getDocumentId(invoiceData)) ||
      (invoiceData?.supplierName && invoiceData?.supplierNumber)
    ) {
      document.title =
        flag === true && sales === false
          ? `${invoiceData?.companyName}_${getDocumentId(invoiceData)}`
          : flag === "purchases" ? `${invoiceData?.supplierName}_${invoiceData.supplierNumber}`
          : flag === false && sales === true
          ? `return_${getDocumentId(invoiceData)}_${invoiceData?.companyName}`
          : `${invoiceData?.companyName}_${getDocumentId(invoiceData)}`;
    }
  }, [invoiceData]);

  useEffect(() => {
    if (AppContext?.userAuthToken || AppContext?.userAuthToken !== "") {
      getPrintInvoice();
    }
  }, [AppContext?.userInfo, AppContext?.userAuthToken]);

  const totalVat = invoiceData?.invoiceproducts
  ?.reduce((accumulator, item) => accumulator + parseFloat(item?.vat || 0), 0);

  const totalVatAsNumber = parseFloat(totalVat);

  // const totalExtraValues = invoiceData?.extravalues?.reduce((sum, item) => sum + (item?.value || 0), 0) || 0;
  // const totalExtraValuesDisc = totalExtraValues - invoiceData?.discount;
  const netAmount = (
    invoiceData?.total + (invoiceData?.vat ?? totalVatAsNumber) - invoiceData?.discount !== invoiceData?.totalAfterVat
  )
    ? invoiceData?.totalAfterVat
    : (AppContext?.userInfo?.addDiscount === true
        ? invoiceData?.totalAfterVat
        : invoiceData?.total + (invoiceData?.vat ?? totalVatAsNumber));

  const isSimplifiedInvoice = ["simplified", "simsi"].includes(
    String(invoiceData?.invoice_category || invoiceData?.invoiceCategory || "").toLowerCase()
  );

  return (
    <Box className="legacy-invoice" sx={{ backgroundColor: "#fff" }} ref={ref}>
      <Grid className="legacy-invoice__header" container spacing={1} sx={{ width: "100%", padding: "2px 32px" }}>
        <Grid item xs={5} sx={{ width: "100%" }}>
          <h3>{userData?.companyName}</h3>
          <h3>C.R: {userData?.companyNumber}</h3>
          <h3>VAT: {userData?.vatNumber} </h3>
        </Grid>

        <Grid item xs={2} sx={{ width: "100%" }}>
          {userData?.logo && userData?.logo !== "" ? (
            <img
              style={{ width: "100%" }}
              src={`${process.env.REACT_APP_API_URL || "http://localhost:3001"}/image-storage/${userData?.logo}`}
              alt=""
            />
          ) : null}
        </Grid>

        <Grid item xs={5} sx={{ width: "100%", textAlign: "right" }}>
          <h3>{userData?.companyNameAR}</h3>
          <h3> {userData?.companyNumber} :س.ت</h3>
          <h3>{userData?.vatNumber} :رقم ضريبي </h3>
        </Grid>
      </Grid>
      {flag === true && sales == false && (
        <h2 style={{ textAlign: "center" }}> Price Offer - عرض سعر</h2>
      )}
      {flag === false && sales == false && (
        <h2 style={{ textAlign: "center" }}>
          {isSimplifiedInvoice
            ? "SIMPLE INVOICE – فاتورة مبسطة"
            : "TAX INVOICE – فاتورة ضريبية"}
        </h2>
      )}
      {flag === false && sales == true && (
        <h2 style={{ textAlign: "center" }}>
          {" "}
          {invoiceData?.zatca_return_type === "DEBIT_NOTE" ? "إشعار مدين" : "إشعار دائن"}
          {" / مرتجع مبيعات"} <br />
          {invoiceData?.zatca_return_type === "DEBIT_NOTE" ? "Debit Note" : "Credit Note"}
        </h2>
      )}
      {flag === "purchases" && (
        <h2 style={{ textAlign: "center" }}>
          {" "}
          فاتورة مشتريات <br /> Purchases Invoices
        </h2>
      )}
      <div className="legacy-invoice__table-wrap" style={{ width: "100%" }}>
        <table className="legacy-invoice__details" style={{ margin: "auto", fontSize: "14px" }}>
          <tr>
            <td className="tdInvoice" style={{ fontWeight: "bold" }}>
              {flag === true
                ? "OFFER NO. / رقم العرض"
                : "INVOICE NO. / رقم الفاتورة"}
            </td>
            <td className="tdInvoice">
              {flag !== "purchases" && getDocumentId(invoiceData)}
              {flag === "purchases" && invoiceData?.supplierNumber}
            </td>
            <td className="tdInvoice" style={{ fontWeight: "bold" }}>
              {sales ? "ORIGINAL INVOICE NO. / رقم الفاتورة الأصلية" : "VAT NO. / الرقم الضريبي"}
            </td>
            <td className="tdInvoice">
              {sales ? invoiceData?.original_invoice_number || "-" : invoiceData?.vatNumber}
            </td>
          </tr>
          <tr>
            <td className="tdInvoice" style={{ fontWeight: "bold" }}>
              {flag === true
                ? "OFFER DATE / تاريخ العرض"
                : "INVOICE DATE / تاريخ الفاتورة"}
            </td>
            <td className="tdInvoice">
              {moment(invoiceData?.invoiceDate).format("YYYY-MM-DD")}
            </td>
            {/* customer address */}
            <td className="tdInvoice" style={{ fontWeight: "bold" }}>
              {sales
                ? "ORIGINAL INVOICE DATE / تاريخ الفاتورة الأصلية"
                : flag === true
                  ? "CLIENT ADDRESS / موقع العميل"
                  : "CUSTOMER ADDRESS / عنوان العميل"}{" "}
            </td>
            <td className="tdInvoice">
              {sales
                ? invoiceData?.original_invoice_date
                  ? moment(invoiceData.original_invoice_date).format("YYYY-MM-DD")
                  : "-"
                : invoiceData?.address}
            </td>
          </tr>
          {sales && (
            <>
              <tr>
                <td className="tdInvoice" style={{ fontWeight: "bold" }}>
                  DOCUMENT NUMBER / رقم المستند
                </td>
                <td className="tdInvoice">
                  {invoiceData?.sr_document_number === null || invoiceData?.sr_document_number === undefined
                    ? "-"
                    : getDocumentId(invoiceData)}
                </td>
                <td className="tdInvoice" style={{ fontWeight: "bold" }}>
                  VAT NO. / الرقم الضريبي
                </td>
                <td className="tdInvoice">{invoiceData?.vatNumber}</td>
              </tr>
            </>
          )}
          <tr>
            <td className="tdInvoice" style={{ fontWeight: "bold" }}>
              {sales ? "CUSTOMER ADDRESS / عنوان العميل" : <>
                {" "}
                {flag === true && "CLIENT ADDRESS / موقع العميل"}
                {flag === false && "CUSTOMER ADDRESS / عنوان العميل"}
                {flag === "purchases" && "SUPPLIER ADDRESS / عنوان المورد"}
              </>}
            </td>
            <td className="tdInvoice">
              {sales
                ? invoiceData?.address
                : flag === "purchases"
                ? invoiceData?.supplierName
                : invoiceData?.companyName}
            </td>
            {/* PO NO. */}
            {sales ? (
              <>
                <td className="tdInvoice" style={{ fontWeight: "bold" }}>
                  CUSTOMER NAME / العميل
                </td>
                <td className="tdInvoice">{invoiceData?.companyName}</td>
              </>
            ) : flag === true ? (
              <>
                <td className="tdInvoice" style={{ fontWeight: "bold" }}>
                  VALIDITY / الصالحية
                </td>
                <td className="tdInvoice">{invoiceData?.validity}</td>
              </>
            ) : (
              <>
                <td className="tdInvoice" style={{ fontWeight: "bold" }}>
                  PAYMENT TERMS / طريقة الدفع{" "}
                </td>
                <td className="tdInvoice">{invoiceData?.payment}</td>
              </>
            )}
          </tr>
          {sales && (
            <tr>
              <td className="tdInvoice" style={{ fontWeight: "bold" }}>
                PAYMENT TERMS / طريقة الدفع
              </td>
              <td className="tdInvoice">{invoiceData?.payment}</td>
              <td className="tdInvoice" style={{ fontWeight: "bold" }}>
                PO NO. / المرجع
              </td>
              <td className="tdInvoice">{invoiceData?.po}</td>
            </tr>
          )}
          <tr>
            {/* {flag === true && ( */}
            <>
              <td className="tdInvoice" style={{ fontWeight: "bold" }}>
                NOTES / ملاحظة
              </td>
              <td className="tdInvoice">{invoiceData?.notes}</td>
            </>
            <>
              <td className="tdInvoice" style={{ fontWeight: "bold" }}>
                NOTES 2 / ملاحظة 2
              </td>
              <td className="tdInvoice">{invoiceData?.notes_2}</td>
            </>
            {/* )} */}
          </tr>
          {flag === false && !sales && (
            <tr>
              <>
                <td className="tdInvoice" style={{ fontWeight: "bold" }}>
                  PO NO. / المرجع
                </td>
                <td className="tdInvoice">{invoiceData?.po}</td>
              </>
            </tr>
          )}
        </table>
      </div>
      {/* items in bill */}
      <Box
        className="legacy-invoice__divider"
        sx={{
          borderBottom: "2px dashed black",
          width: "700px",
          margin: "auto",
          marginTop: "30px",
        }}
      ></Box>
      {/* Products purchased */}
      <div
        className="legacy-invoice__table-wrap legacy-invoice__products-wrap"
        style={{
          width: "100%",
          marginTop: "40px",
          pageBreakAfter: "auto",
        }}
      >
        <table className="legacy-invoice__products" style={{ margin: "auto" }}>
          <tr>
            <th className="thInvoice" style={{ textAlign: "center" }}>
              Sr No. <br />
              رقم
            </th>
            <th className="thInvoice" style={{ textAlign: "center" }}>
              Product Name <br /> المنتج
            </th>
            <th className="thInvoice" style={{ textAlign: "center" }}>
              Description <br /> الوصف
            </th>
            <th className="thInvoice" style={{ textAlign: "center" }}>
              Unit
              <br /> الوحدة
            </th>
            <th className="thInvoice" style={{ textAlign: "center" }}>
              Qty <br /> الكمية
            </th>
            <th className="thInvoice" style={{ textAlign: "center" }}>
              Unit Price <br /> سعر الوحدة
            </th>

            <th className="thInvoice" style={{ textAlign: "center" }}>
              Total <br /> المجموع
            </th>
            {AppContext?.userInfo?.addDiscount === true && (
              <>
                <th className="thInvoice" style={{ textAlign: "center" }}>
                  Discount <br /> الخصم
                </th>
                <th className="thInvoice" style={{ textAlign: "center" }}>
                  Total After Discount <br /> المجموع بعد الخصم
                </th>
              </>
            )}
            <th className="thInvoice" style={{ textAlign: "center" }}>
              VAT {AppContext?.userInfo?.vat}% <br /> الضريبة
            </th>

            <th className="thInvoice" style={{ textAlign: "center" }}>
              Total After VAT
              <br /> المجموع بعد الضرببة
            </th>
          </tr>
          {!!invoiceData?.invoiceproducts?.length &&
            invoiceData?.invoiceproducts?.map((item, i) => (
              <tr key={i}>
                <td className="tdInvoice" style={{ textAlign: "center" }}>
                  {i + 1}
                </td>
                <td className="tdInvoice" style={{ textAlign: "center" }}>
                  {item?.productName}
                </td>
                <td
                  className="thInvoice"
                  style={{ padding: "0px 0px 0px 5px" }}
                >
                  {item?.description}
                </td>
                <td className="tdInvoice" style={{ textAlign: "center" }}>
                  {item?.unit}
                </td>
                <td className="tdInvoice" style={{ textAlign: "center" }}>
                  {item?.qty}
                </td>
                <td className="tdInvoice" style={{ textAlign: "center" }}>
                  {item?.unitPrice}
                </td>

                <td className="tdInvoice" style={{ textAlign: "center" }}>
                  {item?.total}
                </td>
                {AppContext?.userInfo?.addDiscount === true && (
                  <>
                    <td className="tdInvoice" style={{ textAlign: "center" }}>
                      {item?.discount}
                    </td>
                    <td className="tdInvoice" style={{ textAlign: "center" }}>
                      {item?.totalAfterDiscount}
                    </td>
                  </>
                )}
                <td className="tdInvoice" style={{ textAlign: "center" }}>
                  {item?.vat}
                </td>

                <td className="tdInvoice" style={{ textAlign: "center" }}>
                  {AppContext?.userInfo?.addDiscount === true
                    ? item?.totalAfterVat
                    : item?.total + item?.vat}
                </td>
              </tr>
            ))}
        </table>
      </div>

      <div
        className="legacy-invoice__totals-wrap"
        style={{
          width: "fit-content",
          marginTop: "40px",
          marginBottom: "25px",
          marginLeft: "auto",
          marginRight: "auto",
          pageBreakBefore: "auto",
        }}
      >
        <div className="legacy-invoice__totals" style={{ display: "flex", gap: "25px" }}>
          <table className="legacy-invoice__totals-table" style={{ margin: "auto", fontSize: "14px", width: "490px" }}>
            <tr>
              <td className="thInvoice" style={{ fontWeight: "bolder" }}>
                Total Before VAT / الاجمالي قبل الضريية:
              </td>
              <td className="tdInvoice">{invoiceData?.total}</td>
            </tr>
            {AppContext?.userInfo?.addDiscount === true && (
              <>
                <tr>
                  <td className="thInvoice" style={{ fontWeight: "bolder" }}>
                    Discount / الخصم:
                  </td>
                  <td className="tdInvoice">{invoiceData?.discount}</td>
                </tr>
                <tr>
                  <td className="thInvoice" style={{ fontWeight: "bolder" }}>
                    Total After Discount / المجموع بعد الخصم:
                  </td>
                  <td className="tdInvoice">
                    {invoiceData?.totalAfterDiscount}
                  </td>
                </tr>
              </>
            )}
            {invoiceData?.extravalues &&
              invoiceData?.extravalues.length > 0 &&
              invoiceData?.extravalues.map((item) => (
                <tr>
                  <td className="thInvoice" style={{ fontWeight: "bolder" }}>
                    {item?.text}:
                  </td>
                  <td className="tdInvoice">{item?.value}</td>
                </tr>
              ))}
            {invoiceData?.addedvalues &&
              invoiceData?.addedvalues.length > 0 &&
              invoiceData?.addedvalues.map((item) => (
                <tr>
                  <td className="thInvoice" style={{ fontWeight: "bolder" }}>
                    {item?.text}
                  </td>
                  <td className="tdInvoice">{item?.value}</td>
                </tr>
              ))}
            <tr>
              <td className="tdInvoice" style={{ fontWeight: "bolder" }}>
                VAT{" "}
                {AppContext?.userInfo?.vat != null
                  ? AppContext?.userInfo?.vat
                  : 0}
                % / الضريبية :
              </td>
              <td className="tdInvoice">
                {invoiceData?.vat != null
                  ? invoiceData?.vat
                  : invoiceData?.invoiceproducts
                      ?.map((item) => {
                        const vat = +item?.vat;
                        return vat;
                      })
                      .reduce((accumulator, value) => {
                        return +accumulator + +value;
                      }, 0)}
              </td>
            </tr>
            <tr>
              <td className="tdInvoice" style={{ fontWeight: "bolder" }}>
                Net Amount / المبلغ المستحق:
              </td>
              {/* <td className="tdInvoice">{invoiceData?.totalAfterVat}</td> */}
              <td className="tdInvoice">{netAmount}</td>
            </tr>
          </table>
          {flag === false && (
            <img
              className="vat-qr"
              src={invoiceData?.qr}
              style={{ objectFit: "contain" }}
            />
          )}
        </div>
        {(flag === false || flag === "purchases") && (
          <>
            <p style={{ marginTop: flag === false && "unset" }}>
              Saudi Riyals - ريال سعودي
            </p>
            <p style={{ marginBottom: "unset" }}>{userData?.address}</p>
          </>
        )}
      </div>
      {/* {flag === true && ( */}
      {invoiceData?.bank_iban != null && (
        <table
          style={{
            margin: "auto",
            fontSize: "14px",
            width: "55%",
            border: "1px solid black",
          }}
        >
          <tr>
            {/* <td
              style={{
                fontWeight: "bolder",
                borderRight: "1px solid black",
                padding: "8px",
                width: "18%",
              }}
            >
              ايبان البنك\ Bank IBAN
            </td> */}
            <td style={{ padding: "25px" }}>{invoiceData?.bank_iban}</td>
          </tr>
        </table>
      )}
      {/* )} */}
    </Box>
  );
});

export default InvoiceHtml;
